<template>
  <transition name="msgbox">
    <div v-if="previewData.visible" class="preview-container">
      <div class="preview-main">
        <div class="preview-content" @click.stop="endPreview">
          <div class="content-item" style="max-width: 90%;" v-if="obj.type === '1'" @click.stop="preventClickStrike">
            <video class="item-video" id="video" autoplay controls :src="obj.src"></video>
          </div>
          <div class="content-item" style="width: 95%;height: 95%;" v-if="obj.type === '2'">
            <img class="item-img" id="img" :src="obj.src" alt />
          </div>
          <div class="content-item" v-if="obj.type === '6'" @click.stop="preventClickStrike">
            <div class="item-audio">
              <img class="audio-img" src="/static/images/material/material_preview_audio.png" alt />
              <audio class="audio-self" controls autoplay :src="obj.src" alt></audio>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {
  props: ["previewData"],
  data() {
    return {
      obj: {}
    };
  },
  created() {
    this.obj = this.previewData;
  },
  methods: {
    endPreview() {
      this.obj.visible = !this.previewData.visible;
      this.$emit("previewVisible", this.obj);
    },
    preventClickStrike() {
      console.log("阻止点击穿透行为");
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 9999;

  .preview-main {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);

    .preview-content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      /* 水平居中 */
      align-items: center;
      /* 垂直居中 */

      .content-item {
        border: none;

        .item-video {
          width: 100%;
          height: 100%;
        }

        .item-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .item-audio {
          width: 100%;
          height: 450px;
          position: relative;

          .audio-img {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }

          .audio-self {
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
    }
  }
}

.width-long {
  width: 80%;
}

.height-long {
  height: 80%;
}

.msgbox-enter,
.msgbox-leave-to {
  transform: translate(0, 0) scale(0, 0);
}

.msgbox-enter-active,
.msgbox-leave-active {
  transition: all 0.2s;
}

.msgbox-enter-to,
.msgbox-leave {
  transform: translate(0, 0) scale(1, 1);
}
</style>
